import { assert } from '@/core'
import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

export class ApplicationsService extends BaseService {
  static get entity() {
    return 'applications'
  }

  /**
   * Fetch Application data by presents application id.
   *
   * @param {String} param0 Application id.
   * @returns {Object: <ResponseWrapper>}
   */
  static async getById({ id }) {
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/${id}`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   * Fetch Application list.
   *
   * @param {Object} params Request params.
   * @returns {Object: <ResponseWrapper>} Application list.
   */
  static async getList(params = {}) {
    assert.object(params, { required: true })

    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}?${this.querystring(params)}`
      )

      const data = {
        content: response.data.data,
        total: response.data.total,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   * Fetch Application short list.
   *
   * @param {Object} params Request params.
   * @returns {Object: <ResponseWrapper>} Application short list.
   */
  static async getShortList(params = {}) {
    assert.object(params, { required: true })

    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/short?${this.querystring(params)}`
      )

      const data = {
        content: response.data,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   * Fetch Tariffs list.
   *
   * @returns {Object: <ResponseWrapper>} Tariffs list.
   */
  static async getTariff({ type = 'tariffs' }) {
    try {
      const response = await this.request({ auth: true }).get(`/${type}`)

      const data = {
        content: response.data,
      }

      return new ResponseWrapper(response, data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   * Set CODE & CARD tariffs for application.
   *
   * @param {Object} payload Request payload.
   * @returns {Object: <ResponseWrapper>}
   */
  static async setTariff(payload = {}) {
    try {
      const response = await this.request({ auth: true }).post(`${this.entity}/tariffs`, {
        ...payload,
      })

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   * Get applications summary balance info.
   *
   * @param {Object} payload Request payload.
   * @returns {Object: <ResponseWrapper>}
   */
  static async getBalance(payload = {}) {
    try {
      const response = await this.request({ auth: true }).get(`${this.entity}/balance`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async toggleBlockGpay(params = {}) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/GoogleCert?${this.querystring(params)}`
      )

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async toggleEnableGpayActivation({ id }) {
    try {
      const response = await this.request({ auth: true }).put(`${this.entity}/prohibited_activities/${id}`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async destroy({ id }) {
    try {
      const response = await this.request({ auth: true }).delete(`${this.entity}/${id}`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async restore({ id }) {
    try {
      const response = await this.request({ auth: true }).patch(`${this.entity}/restore/${id}`)

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
